import React, { useState } from "react";
import cx from "classnames";
import { dataTestIds } from "data-testids";

interface Props extends React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> {
  className?: string;
}

const ImageWithFallback = ({ className, src, alt, ...rest }: Props) => {
  const [hasError, setHasError] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      {...rest}
      className={cx(className, { hidden: hasError })}
      onError={() => setHasError(true)}
      data-testid={
        dataTestIds.componentLibrary["Atoms.ImageWithFallback.imageContainer"]
      }
    />
  );
};

export default ImageWithFallback;
